import {InputTextV2} from '@prtimes-basis/input';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function CorporateNameKanaField() {
  return (
    <FormField.Root name='companyInfo.corporateNameKana'>
      <Body />

      <FormField.Error />

      <FormField.Description>
        「株式会社」などの法人格を除いてご入力ください
      </FormField.Description>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField({
    hasDescription: true,
  });

  return (
    <InputTextV2
      required
      placeholder='ピーアールタイムズ'
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
